// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //apiUrl: 'https://enlineacl.senace.gob.pe/ApiParticipacionCiudadana/api/',   // APÏ de Produccion  
  //apiUrl: 'https://enlineacl.senace.gob.pe/ApiParticipacionCiudadana/api/',   // APÏ de calidad
  apiUrl: 'https://consultaciudadana.senace.gob.pe/ApiParticipacionCiudadana/api/',   // APÏ enlinea.senace.gob.pe
  apiUrlDownloadById: 'https://eva.senace.gob.pe:8443/AppIntegracionCMIS/rest/WebServiceECM/DownloadByGet?docId',
  apiUrlZip: 'https://enlinea.senace.gob.pe/ApiComunes/api/',
  apiUrlSenaceRuc: 'https://enlinea.senace.gob.pe/ApiComunes/api/ConsultarRUC/',
  apiUrlSenaceDNI: 'https:/enlinea.senace.gob.pe/ApiComunes/api/ConsultarDNI/',
  folderProyecto: 'ParticipacionCiudadana/' // Si el proyecto está en la raíz dejar en blanco. Si está en un subdirectorio por ejemplo desarrollo/moduloC/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
